import { ApolloClient, NormalizedCacheObject } from "@apollo/client"
import dayjs from "dayjs"
import React, { useRef, useState } from "react"
import { Route, Routes, useNavigate } from "react-router-dom"
import { FruitTraceability } from "../../models/traceability/FruitTraceability"
import ContractDetail from "../contracts/ContractDetail"
import { InvoiceDetail } from "../invoice/InvoiceDetail"
import { ContractTraceableDetail } from "./ContractTraceableDetail"
import { PurchaseReportPage } from "./PurchaseReportPage"

type ContractsProps = {
    client: ApolloClient<NormalizedCacheObject>
}

export function TraceCompletedContracts({ client }: ContractsProps) {
    // Defaults to the month to date up to yesterday, the last complete day; on
    // the 1st that is the whole previous month.
    const [endDate, setEndDate] = useState<dayjs.Dayjs>(() => dayjs().subtract(1, 'day').startOf('day'))
    const [startDate, setStartDate] = useState<dayjs.Dayjs>(() => endDate.startOf('month'))
    const [startDateOpen, setStartDateOpen] = useState(false)
    const [endDateOpen, setEndDateOpen] = useState(false)
    const [contracts, setContracts] = useState<FruitTraceability[]>([])

    const navigate = useNavigate()

    const selectedContract = useRef<FruitTraceability>(undefined)

    const onContractDetailClick = (contract: FruitTraceability) => {
        selectedContract.current = contract
        navigate(`contract_traceable_detail/${contract.contract_id}`)
    }

    return (
        <Routes>
            <Route path="contract_detail" element={<ContractDetail client={client} />}></Route>
            <Route path="invoice_detail/:id" element={<InvoiceDetail client={client} />}></Route>
            <Route path="contract_traceable_detail/:id" element={<ContractTraceableDetail/>}></Route>
            <Route path="/" element={<PurchaseReportPage
                client={client}
                startDate={startDate}
                endDate={endDate}
                setStartDate={setStartDate}
                setEndDate={setEndDate}
                startDateOpen={startDateOpen}
                setStartDateOpen={setStartDateOpen}
                setEndDateOpen={setEndDateOpen}
                endDateOpen={endDateOpen}
                onViewMoreClick={c => onContractDetailClick(c)}
                contracts={contracts}
                setContracts={setContracts}
            />}></Route>
        </Routes>
    )
}